import React from "react";
import { useIntl } from "react-intl";
import { useFormikContext } from "formik";
import { useHistory } from "react-router-dom";
import { Space, Button } from "@masterteam/mt-design-react";

import "./style.scss";

const Actions = ({
  cancelRoute,
  customButton,
  readOnly,
  handleSaveAsDraft
}) => {
  const intl = useIntl();
  const history = useHistory();
  const { isValid } = useFormikContext();

  return (
    <Space className="actions" align="center">
      <Button
        shape="round"
        backgroundColor="#B5B6B7"
        onClick={() => history.push(cancelRoute)}
        style={{
          width: "80px"
        }}
      >
        {intl.formatMessage({ id: "common.cancel" })}
      </Button>

      {!readOnly && (
        <>
          {(customButton?.length > 0 &&
            customButton?.map((item) => (
              <Button shape="round" onClick={item?.action} type={item?.type}>
                {intl.formatMessage({ id: item?.title })}
              </Button>
            ))) || (
            <>
              <Button
                shape="round"
                type="button"
                onClick={handleSaveAsDraft}
                backgroundColor="var(--secondary-color)"
              >
                {intl.formatMessage({ id: "common.save-as-draft" })}
              </Button>

              <Button
                shape="round"
                type="submit"
                disabled={!isValid}
                style={{
                  width: "80px"
                }}
              >
                {intl.formatMessage({ id: "common.send" })}
              </Button>
            </>
          )}
        </>
      )}
    </Space>
  );
};

export default Actions;
